import React, { useRef, useState, useEffect } from "react";
import Cookies from "js-cookie";
import moment from "moment";
import { toast } from "react-toastify";

const AddGovtOrderDetailsModal = ({ formRef, getData }) => {
  const [company, setCompany] = useState([]);
  const [selectedCompanyId, setSelectedCompanyId] = useState("");
  console.log(selectedCompanyId);
  const [orderId, setOrderId] = useState("");
  const [selectedLocation, setSelectedLocation] = useState("");
  const [selectedRca, setSelectedRca] = useState("");
  const [selectedSize, setSelectedSize] = useState("");
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const [OrderDetails, setOrderDetails] = useState([]);

  const [selectedAlloted, setSelectedAlloted] = useState("");
  console.log(selectedAlloted);
  const [rowAddData, setRowAddData] = useState({
    company_id: "",
    order_id: "",
    location: "",
    rca_qty: "",
    size: "",
    order_details: "",
    order_qty: "",
    alloted: "",
  });

  const getCompany = async () => {
    const BASE_URL = SERVER_URL + `/api/company/all-company-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    // console.log(result.data)
    setCompany(result.data);
  };

  useEffect(() => {
    getCompany();
  }, []);

  const handleCompanyChange = (e) => {
    const selectedCompany = company.find(
      (item) =>
        item.company_name === e.target.value.split(",")[0] &&
        item.location === e.target.value.split(",")[1]
    );

    // setLocation(selectedCompany?.location || "");
    setSelectedCompanyId(selectedCompany?.id || "");
  };
  const handleLocationChange = (e) => {
    const selectedLocation = OrderDetails.find(
      (item) => item.location === e.target.value
    );
    // console.log("selectedLocation", selectedLocation)
    setSelectedLocation(selectedLocation.location);
    setOrderId(selectedLocation?.id || "");
  };

  const handleRcaChange = (e) => {
    const selectedRca = OrderDetails.find(
      (item) => item.rca_no === e.target.value
    );
    // console.log("selectedLocation", selectedLocation)
    setSelectedRca(selectedRca.rca_no);
  };

  const handleSizeChange = (e) => {
    const selectedSize = OrderDetails.find(
      (item) => item.size === e.target.value
    );
    // console.log("selectedLocation", selectedSize)
    setSelectedSize(selectedSize.size);
  };
  const handleAllotedChange = (e) => {
    const selectedOrder = OrderDetails.find(
      (item) => item.alloted == e.target.value
    );
    setSelectedAlloted(selectedOrder.alloted);
  };

  const getOrderDetails = async () => {
    const BASE_URL = SERVER_URL + `/api/order/all-orderDetails/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    console.log(result.data);
    setOrderDetails(result.data);
  };

  useEffect(() => {
    getOrderDetails();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setRowAddData(() => {
      return {
        ...rowAddData,
        [name]: value,
      };
    });
  };

  const handleAddDataSubmit = async (e) => {
    e.preventDefault();
    const { rca_qty, order_qty, order_details } = rowAddData;
    let BASE_URL = SERVER_URL + `/api/order/govtOrderDetails/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        company_id: selectedCompanyId,
        order_id: orderId,
        location: selectedLocation,
        rca_qty,
        size: selectedSize,
        alloted: selectedAlloted,
        order_details,
        order_qty,
      }),
    });
    const response = await res.json();
    console.log("response", response);

    if (res.ok) {
      console.log(response);
      setTimeout(() => {
        toast.success(response.message);
        formRef.current.reset();
        // navigate("/dashboard");
      }, 1000);
      getData();
    } else {
      toast.error(response.message);
      getData();
    }
  };

  return (
    <>
      <div
        className="modal custom-modal fade"
        id="exampleModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              {/* <h5 class="modal-title" id="imageZoomModalTitle">Galeria</h5> */}
              <button
                type="button"
                class="custon-close-button-color close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div className="col-12 grid-margin">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Add Govt Order Details</h4>
                    <form className="form-sample" ref={formRef}>
                      {/* <p className="card-description">Personal info</p> */}
                      <div className="row">
                        <div class="col-md-3">
                          <div class="form-group">
                            <label>Location</label>
                            <select
                              className="form-control form-control-lg"
                              onChange={handleLocationChange}
                            >
                              <option>Select</option>
                              {OrderDetails.map((item, id) => {
                                return (
                                  <>
                                    <option key={id}>{item.location}</option>
                                  </>
                                );
                              })}
                            </select>
                          </div>
                        </div>
                        <div class="col-md-3">
                          <div class="form-group">
                            <label>Company Name</label>
                            <select
                              className="form-control form-control-lg"
                              onChange={handleCompanyChange}
                            >
                              <option>Select</option>
                              {company.map((item, id) => {
                                return (
                                  <>
                                    <option
                                      key={id}
                                    >{`${item.company_name},${item.location}`}</option>
                                  </>
                                );
                              })}
                            </select>
                          </div>
                        </div>
                        <div class="col-md-3">
                          <div class="form-group">
                            <label>Size</label>
                            <select
                              className="form-control form-control-lg"
                              onChange={handleSizeChange}
                            >
                              <option>Select</option>
                              {OrderDetails.map((item, id) => {
                                return (
                                  <>
                                    <option key={id}>{item.size}</option>
                                  </>
                                );
                              })}
                            </select>
                          </div>
                        </div>
                        <div class="col-md-3">
                          <div class="form-group">
                            <label>Alloted</label>
                            <select
                              className="form-control form-control-lg"
                              onChange={handleAllotedChange}
                            >
                              <option>Select</option>
                              {OrderDetails.map((item, id) => {
                                return (
                                  <>
                                    <option key={id}>{item.alloted}</option>
                                  </>
                                );
                              })}
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="Placed">Order Placed</label>
                            <input
                              type="text"
                              className="form-control"
                              name="order_placed"
                              id="Placed"
                              placeholder="Order Placed"
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                        <div className="col-md-8">
                          <div className="form-group">
                            <label htmlFor="Details">Order Details</label>
                            <input
                              type="text"
                              className="form-control"
                              name="order_details"
                              id="Details"
                              placeholder="Order Details"
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="rca_qty">RCA Quantity</label>
                            <input
                              type="text"
                              className="form-control"
                              name="rca_qty"
                              id="rca_qty"
                              placeholder="RCA Quantity"
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="Order">Order Quantity</label>
                            <input
                              type="text"
                              className="form-control"
                              name="order_qty"
                              id="Order"
                              placeholder="Order Quantity"
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                      </div>
                      <button
                        className="btn btn-primary mr-2 mt-3"
                        type="submit"
                        onClick={handleAddDataSubmit}
                      >
                        Save
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddGovtOrderDetailsModal;
